import React from "react";
import { Calendar, Badge, Alert, Modal } from "antd";
import fetch from "unfetch";
import moment from "moment";
moment.locale("fr");
import {
  Input,
  Select,
  Form,
  TimePicker,
  Spin,
  Divider,
  Icon,
  Button,
  Upload,
  notification,
} from "antd";
import { Tabs, Table } from "antd";

const TabPane = Tabs.TabPane;
const { TextArea } = Input;
const FormItem = Form.Item;
const Option = Select.Option;
const OptGroup = Select.OptGroup;
const confirm = Modal.confirm;

function onChange(pagination, filters, sorter) {
  console.log("params", pagination, filters, sorter);
}

class Calandar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      visible2: false,
      value: moment(),
      selectedValue: moment(),
      activeTab: "1",
      listData: {},
      fileList: [],
      selectedMeeting: null,
      presentOnly: false,
      visibleCustomRelance: false,
      selectedCustomRelance: null,
      customRelanceLoading: false,
    };
    this.getListData = this.getListData.bind(this);
    this.dateCellRender = this.dateCellRender.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
  }

  getListData(value) {
    if (this.state.events) {
      let eventsDate = this.state.events.filter((ev) => {
        return moment(ev.date).format("DDMMYYYY") == value.format("DDMMYYYY");
      });
      return eventsDate;
    }
  }

  dateCellRender(value) {
    const listData = this.getListData(value);
    return (
      <ul className="events">
        {listData.map((item) => (
          <li key={item.name}>
            <Badge status={item.type} text={item.name} />
          </li>
        ))}
      </ul>
    );
  }

  onSelect = (value) => {
    this.setState({
      value,
      selectedValue: value,
      visible: true,
    });
  };

  onPanelChange = (value) => {
    this.setState({
      value: value,
      selectedValue: value,
    });
  };

  handleOk = (e) => {
    e.preventDefault();

    if (this.state.activeTab == "2") {
      this.props.form.validateFieldsAndScroll((err, values) => {
        const formData = new FormData();
        this.state.fileList.forEach((file) => {
          formData.append("files[]", file);
        });
        Object.keys(values).map((key) => {
          formData.append(key, JSON.stringify(values[key]));
        });
        formData.append(
          "hour",
          JSON.stringify({
            start: values.timeStart,
            end: values.timeEnd,
          })
        );
        formData.append("status", "validated");
        formData.append("type", "error");

        fetch("/api/event", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": localStorage.getItem("x-access-token"),
          },
          body: formData,
        })
          .then((res) => res.json())
          .then((data) => {
            this.setState({
              events: [...this.state.events, data],
              visible: false,
            });
          });
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  };

  handleCancel = () => {
    this.props.form.resetFields();
    this.setState({
      visible: false,
    });
  };

  showModal = (item) => {
    const participants = [];

    item.participants.map((p) => {
      let presence = item.presence.filter((i) => {
        return i._id == p._id;
      })[0];
      participants.push({
        ...p,
        presence: presence ? presence.status : "",
      });
    });

    this.setState({
      visible2: true,
      participants: participants,
      selectedMeeting: item._id,
    });
  };

  handleOk2 = (e) => {
    console.log(e);
    this.setState({
      visible2: false,
    });
  };

  handleCancel2 = () => {
    console.log("Clicked cancel button");
    this.setState({
      visible2: false,
    });
  };

  componentDidMount() {
    fetch("/api/event", {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          events: data,
        });

        fetch("/api/user", {
          credentials: "include",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": localStorage.getItem("x-access-token"),
          },
        })
          .then((res) => res.json())
          .then((data) => {
            this.setState({
              users: data.users,
              filterData: data.users,
              groups: data.groups,
            });
          });
      });
  }

  onRemove(file) {
    const index = this.state.fileList.indexOf(file);
    const newFileList = this.state.fileList.slice();
    newFileList.splice(index, 1);
    this.setState({
      fileList: newFileList,
    });
    return {
      fileList: newFileList,
    };
  }

  beforeUpload(file) {
    this.setState({
      fileList: [...this.state.fileList, file],
    });
    return false;
  }

  deleteItem(i) {
    fetch("/api/event/" + i._id, {
      credentials: "include",
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((r) => r.json())
      .then((res) => {
        this.setState({
          events: this.state.events.filter((e) => {
            return e._id !== i._id;
          }),
        });
      });
  }

  showRelance(id) {
    confirm({
      title: "Voulez-vous effectuer une relance des invitations en attente ?",
      content:
        "Toutes les personnes invitées qui n'ont toujours pas répondu à l'invitation recevront un email de relance",
      okText: "Valider",
      cancelText: "Annuler",
      onOk: () => {
        fetch("/api/event/relance/" + id, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": localStorage.getItem("x-access-token"),
          },
        })
          .then((r) => r.json())
          .then((res) => {
            notification["success"]({
              message: "Relances envoyées",
              description: "Les relances ont été envoyées",
            });
          });
      },
      onCancel: () => {},
    });
  }

  showCustomRelance(event) {
    this.props.form.resetFields([
      "customRelanceSubject",
      "customRelanceMessage",
      "customRelanceAudience",
    ]);
    this.setState({
      visibleCustomRelance: true,
      selectedCustomRelance: event,
    });
  }

  handleCustomRelance = () => {
    this.props.form.validateFields(
      ["customRelanceSubject", "customRelanceMessage", "customRelanceAudience"],
      (err, values) => {
        if (err || !this.state.selectedCustomRelance) return;

        this.setState({ customRelanceLoading: true });
        fetch(
          "/api/event/relance/custom/" + this.state.selectedCustomRelance._id,
          {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-access-token": localStorage.getItem("x-access-token"),
            },
            body: JSON.stringify({
              subject: values.customRelanceSubject,
              message: values.customRelanceMessage,
              audience: values.customRelanceAudience,
            }),
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (!data.success) throw new Error("Impossible de créer la relance.");
            this.setState({
              visibleCustomRelance: false,
              selectedCustomRelance: null,
              customRelanceLoading: false,
            });
            notification["success"]({
              message: "Relance personnalisée créée",
              description: `${data.recipients} destinataire(s) seront contactés.`,
            });
          })
          .catch(() => {
            this.setState({ customRelanceLoading: false });
            notification["error"]({
              message: "Relance non créée",
              description: "Une erreur est survenue. Aucun envoi n'a été confirmé.",
            });
          });
      }
    );
  };

  handleFilter(val, option) {
    return option.props.filter.toLowerCase().indexOf(val.toLowerCase()) >= 0;
  }

  render() {
    const { value } = this.state;
    const { visible, confirmLoading, confirmLoading2 } = this.state;
    const { visible2 } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const config = {
      rules: [
        {
          type: "object",
          required: true,
          message: "Please select time!",
        },
      ],
    };
    const listData = this.getListData(value);

    const columns = [
      {
        title: "Nom",
        dataIndex: "name",
        render: (text, record) => (
          <b>
            {(record.lastname && record.lastname.toUpperCase()) || ""}{" "}
            {record.firstname}
          </b>
        ),
      },
      {
        title: "Société",
        dataIndex: "company",
        render: (text, record) => record.company.name,
      },
      {
        title: "Présence",
        dataIndex: "presence",
        //sorter: (a, b) => a.presence.status.length - b.name.length,
        // filters: [
        //   {
        //     text: "Présent",
        //     value: "validated",
        //   },
        // ],
        // onFilter: (value, record) =>
        //   record.presence && record.presence === value,
        render: (text, record) => {
          if (record.presence) {
            if (record.presence == "validated") {
              return <span style={{ color: "#52c41a" }}>Validé</span>;
            } else {
              return <span style={{ color: "#f5222d" }}>Refusé</span>;
            }
          } else {
            return <span style={{ color: "#fa8c16" }}>En attente</span>;
          }
        },
      },
    ];

    return (
      <div style={{ position: "relative" }}>
        <h4 style={{ textAlign: "center", textTransform: "capitalize" }}>
          {this.state.selectedValue.format("MMMM YYYY")}
        </h4>
        <Divider />
        {this.state.events ? (
          <div className="widthModal">
            <Calendar
              value={this.state.selectedValue}
              dateCellRender={this.dateCellRender}
              onSelect={this.onSelect}
              onPanelChange={this.onPanelChange}
              headerRender={() => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      position: "absolute",
                      top: 3,
                      width: "100%",
                    }}
                  >
                    <div
                      onClick={() => {
                        this.setState({
                          selectedValue: this.state.selectedValue.subtract(
                            1,
                            "month"
                          ),
                        });
                      }}
                      style={{
                        cursor: "pointer",
                        width: 32,
                        height: 32,
                        border: "1px #E3E3E3 solid",
                        borderRadius: 4,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon type="left" />
                    </div>
                    <div
                      onClick={() => {
                        this.setState({
                          selectedValue: this.state.selectedValue.add(
                            1,
                            "month"
                          ),
                        });
                      }}
                      style={{
                        cursor: "pointer",
                        width: 32,
                        height: 32,
                        border: "1px #E3E3E3 solid",
                        borderRadius: 4,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon type="right" />
                    </div>
                  </div>
                );
              }}
            />
            <Modal
              title={this.state.selectedValue.format("dddd DD MMMM YYYY")}
              className="day-modal"
              visible={visible}
              onOk={this.handleOk}
              confirmLoading={confirmLoading}
              onCancel={this.handleCancel}
              cancelText={"Annuler"}
              width={900}
            >
              <Tabs
                onChange={(key) => {
                  this.setState({ activeTab: key });
                }}
                activeKey={this.state.activeTab}
              >
                <TabPane tab="Liste des evenements" key="1">
                  <ul className="events-holder">
                    {listData.map((item, idx) => (
                      <li className="test">
                        <div
                          className={
                            "box " + (idx == listData.length - 1 ? "end" : "")
                          }
                        >
                          <div className="left">
                            <Badge
                              className="badge"
                              status={item.type}
                              text={
                                moment(item.hour.start).format("HH[h]mm") +
                                "-" +
                                moment(item.hour.end).format("HH[h]mm") +
                                " " +
                                item.name
                              }
                            />
                            <div className="infos">
                              <div className="place">
                                <Icon
                                  type="home"
                                  style={{
                                    fontSize: "1.2rem",
                                    marginRight: "15px",
                                  }}
                                />
                                Lieu : {item.address}
                              </div>
                              <div className="creator">
                                <Icon
                                  type="user"
                                  style={{
                                    fontSize: "1.2rem",
                                    marginRight: "15px",
                                  }}
                                />
                                Organisateur :{" "}
                                {item.creator.firstname +
                                  " " +
                                  item.creator.lastname}
                              </div>
                            </div>
                            <div className="description">{item.infos}</div>
                            {this.props.user &&
                            (this.props.user.admin ||
                              this.props.user.email === item.creator.email ||
                              this.props.user.group.filter((f) => {
                                return f.slug == "membre-du-bureau";
                              }).length > 0) ? (
                              <div className="buttonsContainer">
                                <Button
                                  onClick={() => {
                                    this.showModal(item);
                                  }}
                                >
                                  Participants
                                </Button>
                                {this.props.user.admin ||
                                this.props.user.group.filter((f) => {
                                  return f.slug == "membre-du-bureau";
                                }).length > 0 ? (
                                  <Button
                                    onClick={() => {
                                      Modal.confirm({
                                        title:
                                          "Merci de confirmer la suppression de l'évènement",
                                        content: "",
                                        okText: "Valider",
                                        cancelText: "Annuler",
                                        onOk: () => {
                                          this.deleteItem(item);
                                        },
                                        onCancel: () => {},
                                      });
                                    }}
                                    type="danger"
                                    style={{
                                      marginLeft: "15px",
                                    }}
                                  >
                                    Supprimer
                                  </Button>
                                ) : null}
                                {this.props.user.email ===
                                  "git@impaakt.fr" ||
                                (this.props.user &&
                                  this.props.user._id == item.creator._id) ||
                                (this.props.user &&
                                  this.props.user.group &&
                                  this.props.user.group.filter(
                                    (grp) => grp.slug === "membre-du-bureau"
                                  ).length > 0) ? (
                                  <React.Fragment>
                                    <Button
                                      style={{ marginLeft: 15 }}
                                      onClick={() => {
                                        this.showRelance(item._id);
                                      }}
                                    >
                                      Relance
                                    </Button>
                                    <Button
                                      style={{ marginLeft: 15 }}
                                      onClick={() => this.showCustomRelance(item)}
                                    >
                                      Relance personnalisée
                                    </Button>
                                  </React.Fragment>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </TabPane>
                {this.props.user &&
                (this.props.user.admin ||
                  this.props.user.group.filter((f) => {
                    return f.slug == "membre-du-bureau";
                  }).length > 0) ? (
                  <TabPane tab="Ajouter un evenement" key="2">
                    <Form>
                      <FormItem {...formItemLayout} label="Titre">
                        {getFieldDecorator("name", {
                          rules: [
                            {
                              required: true,
                              message: "Ce champ est obligatoire",
                            },
                          ],
                        })(<Input placeholder={"Titre de l'évènement"} />)}
                      </FormItem>
                      <FormItem {...formItemLayout} label="Pièce(s) jointe(s)">
                        <Upload
                          onRemove={(file) => this.onRemove(file)}
                          fileList={this.state.fileList}
                          beforeUpload={(file) => this.beforeUpload(file)}
                          name="logo"
                        >
                          <Button>
                            <Icon type="upload" /> Sélectionner les pièces
                            jointes à ajouter
                          </Button>
                        </Upload>
                      </FormItem>
                      <FormItem {...formItemLayout} label="Lieu">
                        {getFieldDecorator("address", {
                          rules: [
                            {
                              required: true,
                              message: "Ce champ est obligatoire",
                            },
                          ],
                        })(
                          <Input
                            placeholder={"Précisez le lieu de l'évènement"}
                          />
                        )}
                      </FormItem>

                      <FormItem {...formItemLayout} label="Heure de début">
                        {getFieldDecorator("timeStart", {
                          rules: [
                            {
                              required: true,
                              message: "Ce champ est obligatoire",
                            },
                          ],
                        })(
                          <TimePicker
                            style={{
                              width: "100%",
                            }}
                            minuteStep={15}
                            placeholder="Début"
                            defaultOpenValue={moment("10:00", "HH:mm")}
                            format={"HH:mm"}
                          />
                        )}
                      </FormItem>

                      <FormItem {...formItemLayout} label="Heure de fin">
                        {getFieldDecorator("timeEnd", {
                          rules: [
                            {
                              required: true,
                              message: "Ce champ est obligatoire",
                            },
                          ],
                        })(
                          <TimePicker
                            style={{
                              width: "100%",
                            }}
                            minuteStep={15}
                            placeholder="Fin"
                            defaultOpenValue={moment("17:00", "HH:mm")}
                            format={"HH:mm"}
                          />
                        )}
                      </FormItem>

                      <FormItem {...formItemLayout} label="Invitations">
                        {getFieldDecorator("invitation", {
                          rules: [
                            {
                              required: true,
                              message: "Ce champ est obligatoire",
                            },
                          ],
                        })(
                          <Select
                            mode="tags"
                            style={{
                              width: "100%",
                            }}
                            placeholder="Sélectionner un groupe ou des utilisateurs"
                            filter
                            optionFilterProp="filter"
                            notFoundContent={null}
                          >
                            <OptGroup label="Année en cours">
                              <Option
                                filter="actif"
                                value="group-actif"
                                key={"group-actif"}
                              >
                                <b
                                  style={{
                                    textTransform: "uppercase",
                                  }}
                                >
                                  <Badge status="success" /> Actifs
                                </b>
                              </Option>
                              <Option
                                filter="passif"
                                value="group-passif"
                                key={"group-passif"}
                              >
                                <b
                                  style={{
                                    textTransform: "uppercase",
                                  }}
                                >
                                  <Badge status="warning" /> Passifs
                                </b>
                              </Option>
                            </OptGroup>
                            <OptGroup label="Groupes">
                              {this.state.groups
                                ? this.state.groups.map((g) => {
                                    return (
                                      <Option
                                        filter={g.slug}
                                        key={"group-" + g.slug}
                                      >
                                        <b>
                                          <Badge status="default" />
                                          {g.title}
                                        </b>
                                      </Option>
                                    );
                                  })
                                : ""}
                            </OptGroup>
                            <OptGroup label="Utilisateurs">
                              {this.state.users
                                ? this.state.users
                                    .filter((u) => {
                                      return u.email;
                                    })
                                    .map((u) => {
                                      return (
                                        <Option
                                          filter={
                                            u.company.name +
                                            " " +
                                            u.firstname +
                                            " " +
                                            u.lastname
                                          }
                                          key={u.email}
                                        >
                                          <b>
                                            {u.company
                                              ? u.company.name
                                                  .trim()
                                                  .toUpperCase() + " - "
                                              : ""}
                                          </b>{" "}
                                          {u.lastname
                                            ? u.lastname.toUpperCase()
                                            : ""}{" "}
                                          {u.firstname
                                            ? u.firstname.trim().charAt(0)
                                            : ""}
                                          .
                                        </Option>
                                      );
                                    })
                                : ""}
                            </OptGroup>
                          </Select>
                        )}
                      </FormItem>

                      <FormItem {...formItemLayout} label="Description">
                        {getFieldDecorator("infos", {
                          rules: [
                            {
                              required: true,
                              message: "Ce champ est obligatoire",
                            },
                          ],
                        })(
                          <TextArea
                            autosize={{
                              minRows: 5,
                              maxRows: 10,
                            }}
                            placeholder={"Courte description de l'évènement"}
                          />
                        )}
                      </FormItem>
                    </Form>
                  </TabPane>
                ) : (
                  ""
                )}
              </Tabs>
            </Modal>
            <Modal
              title="Relance personnalisée"
              visible={this.state.visibleCustomRelance}
              onOk={this.handleCustomRelance}
              onCancel={() =>
                this.setState({
                  visibleCustomRelance: false,
                  selectedCustomRelance: null,
                })
              }
              confirmLoading={this.state.customRelanceLoading}
              okText="Créer la relance"
              cancelText="Annuler"
              destroyOnClose={true}
            >
              <Form>
                <FormItem label="Objet">
                  {getFieldDecorator("customRelanceSubject", {
                    rules: [
                      { required: true, message: "Veuillez renseigner l'objet." },
                    ],
                  })(<Input placeholder="Ex. Erratum — modification de l'horaire" />)}
                </FormItem>
                <FormItem label="Message">
                  {getFieldDecorator("customRelanceMessage", {
                    rules: [
                      { required: true, message: "Veuillez renseigner le message." },
                    ],
                  })(
                    <TextArea
                      autosize={{ minRows: 6, maxRows: 12 }}
                      placeholder="Saisissez le message à envoyer aux participants."
                    />
                  )}
                </FormItem>
                <FormItem label="Destinataires">
                  {getFieldDecorator("customRelanceAudience", {
                    initialValue: "pending",
                  })(
                    <Select>
                      <Option value="pending">Invités sans réponse</Option>
                      <Option value="all">Tous les participants</Option>
                    </Select>
                  )}
                </FormItem>
              </Form>
            </Modal>
            <Modal
              title="Participants"
              visible={visible2}
              onOk={this.handleOk2}
              confirmLoading={confirmLoading2}
              onCancel={this.handleCancel2}
              cancelText={"Annuler"}
              width={900}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontSize: "0.95rem",
                  fontWeight: "600",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ color: "#52c41a" }}>
                    {this.state.participants &&
                      this.state.participants.filter(
                        (f) => f.presence && f.presence === "validated"
                      ).length}{" "}
                    Présents
                  </p>
                  <p
                    style={{
                      color: "#f5222d",
                      marginRight: 10,
                      marginLeft: 10,
                    }}
                  >
                    {this.state.participants &&
                      this.state.participants.filter(
                        (f) => f.presence && f.presence !== "validated"
                      ).length}{" "}
                    Absents
                  </p>
                  <p style={{ color: "#fa8c16" }}>
                    {this.state.participants &&
                      this.state.participants.filter((f) => !f.presence)
                        .length}{" "}
                    Pas de réponse
                  </p>
                </div>
                <div
                  style={{
                    marginBottom: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    onClick={() => {
                      this.setState({
                        presentOnly: !this.state.presentOnly,
                      });
                    }}
                    type="primary"
                  >
                    {this.state.presentOnly
                      ? "Voir tout"
                      : "Voir uniquement les présents"}
                  </Button>
                  <Button
                    onClick={() => {
                      window.open(
                        `/api/meeting/${this.state.selectedMeeting}/participants`
                      );
                    }}
                    type="link"
                  >
                    Télécharger la liste des présents
                  </Button>
                </div>
              </div>

              <Table
                columns={columns}
                dataSource={
                  this.state.participants &&
                  this.state.participants.filter((f) => {
                    if (this.state.presentOnly) {
                      return f.presence && f.presence === "validated";
                    }
                    return f;
                  })
                }
                onChange={onChange}
              />
            </Modal>
          </div>
        ) : (
          <div
            style={{
              height: "500px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin size="large" />
          </div>
        )}
      </div>
    );
  }
}

export default Form.create()(Calandar);



// WEBPACK FOOTER //
// ./components/calandar.js